import type { ReportSubmissionTiming } from "./models";

export const SHANGHAI_TIME_ZONE = "Asia/Shanghai";
export const MAKEUP_DEADLINE_MINUTES = 12 * 60;

export const reportSubmissionTimingLabels: Record<ReportSubmissionTiming, string> = {
  normal: "正常上报",
  makeup_before_noon: "次日12:00前补报",
  overdue: "逾期补报",
};

export interface ShanghaiDateTime {
  date: string;
  minutesSinceMidnight: number;
}

const dateTimeFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: SHANGHAI_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

export function toShanghaiDateTime(at: Date = new Date()): ShanghaiDateTime {
  const parts = Object.fromEntries(
    dateTimeFormatter
      .formatToParts(at)
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, part.value]),
  );
  const hour = Number(parts.hour) % 24;
  return {
    date: `${parts.year}-${parts.month}-${parts.day}`,
    minutesSinceMidnight: hour * 60 + Number(parts.minute),
  };
}

export function addIsoCalendarDays(date: string, days: number): string {
  const [year, month, day] = date.split("-").map(Number);
  return new Date(Date.UTC(year!, month! - 1, day! + days)).toISOString().slice(0, 10);
}

export function classifyDailyReportTiming(
  studyDate: string,
  at: Date = new Date(),
): ReportSubmissionTiming {
  const current = toShanghaiDateTime(at);
  if (current.date <= studyDate) return "normal";
  if (
    current.date === addIsoCalendarDays(studyDate, 1)
    && current.minutesSinceMidnight < MAKEUP_DEADLINE_MINUTES
  ) {
    return "makeup_before_noon";
  }
  return "overdue";
}

export function isFutureStudyDate(studyDate: string, at: Date = new Date()): boolean {
  return studyDate > toShanghaiDateTime(at).date;
}
